import { KeyRound, Trash2 } from "lucide-react";
import { revokeKey } from "../../api/admin";
import { NeuButton } from "../../components/neu/Neu";

export const ApiKeyRow = ({ item, reload }) => (
  <li
    data-testid={`api-key-row-${item.id}`}
    className="flex flex-wrap items-center justify-between gap-3 overflow-hidden rounded-2xl border border-border/50 px-4 py-3 shadow-neu-sm"
  >
    <span className="flex min-w-0 items-center gap-2 break-all text-sm font-semibold">
      <KeyRound className="h-4 w-4 shrink-0 text-primary" />
      {item.name}
    </span>
    <code className="break-all font-mono text-xs text-muted-foreground">{item.prefix}…</code>
    <span className="break-all font-mono text-[11px] text-muted-foreground">{item.scopes.join(", ")}</span>
    <span className={`text-xs font-bold ${item.active ? "text-success" : "text-destructive"}`}>
      {item.active ? "active" : "revoked"}
    </span>
    <NeuButton
      variant="danger"
      className="px-3 py-2"
      data-testid={`api-key-revoke-${item.id}`}
      onClick={async () => {
        await revokeKey(item.id);
        reload();
      }}
    >
      <Trash2 className="h-4 w-4" />
    </NeuButton>
  </li>
);
